import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "BR_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#BR_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#093"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "BR_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#BR_svg__b)" }, /* @__PURE__ */ e.createElement(
    "g",
    {
      filter: "url(#BR_svg__filter0_d_4799_265981)",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M15.927 3.704l12.202 8.504L15.76 20.17 3.809 12.043l12.118-8.339z",
        fill: "#FFD221"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M15.927 3.704l12.202 8.504L15.76 20.17 3.809 12.043l12.118-8.339z",
        fill: "url(#BR_svg__paint0_linear_4799_265981)"
      }
    )
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16 17.2a5 5 0 100-10 5 5 0 000 10z",
      fill: "#2E42A5"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "BR_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 11,
      y: 7,
      width: 10,
      height: 11
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 17.2a5 5 0 100-10 5 5 0 000 10z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#BR_svg__c)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.38 14.57l-.223.117.042-.248-.18-.176.25-.037.111-.226.112.226.25.037-.181.176.042.248-.223-.117zM16.38 14.57l-.223.117.042-.248-.18-.176.25-.037.111-.226.112.226.25.037-.181.176.042.248-.223-.117zM16.38 15.77l-.223.118.042-.25-.18-.175.25-.036.111-.227.112.227.25.036-.181.176.042.249-.223-.118zM15.38 11.57l-.223.117.042-.248-.18-.176.25-.037.111-.226.112.226.25.037-.181.176.042.248-.223-.117zM15.38 13.57l-.223.117.042-.248-.18-.176.25-.037.111-.226.112.226.25.037-.181.176.042.248-.223-.117zM13.98 12.57l-.224.117.043-.248-.18-.176.249-.037.112-.226.111.226.25.037-.18.176.042.248-.223-.117zM12.58 13.37l-.224.117.043-.248-.181-.177.25-.036.111-.226.112.226.25.036-.181.177.043.248-.224-.117zM17.18 9.97l-.223.118.043-.249-.18-.176.25-.036.11-.227.113.227.25.036-.181.176.042.249-.223-.118z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.926 10.997l.15-1.994c4.798.362 8.585 1.94 11.313 4.745l-1.434 1.395c-2.364-2.433-5.692-3.819-10.03-4.146z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.29 10.603l.05-.498c3.094.32 5.747 1.505 7.951 3.552l-.34.366c-2.125-1.971-4.676-3.11-7.662-3.42z",
      fill: "#093"
    }
  )))),
  /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
    "linearGradient",
    {
      id: "BR_svg__paint0_linear_4799_265981",
      x1: 32,
      y1: 24,
      x2: 32,
      y2: 0,
      gradientUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ e.createElement("stop", { stopColor: "#FFC600" }),
    /* @__PURE__ */ e.createElement("stop", { offset: 1, stopColor: "#FFDE42" })
  ), /* @__PURE__ */ e.createElement(
    "filter",
    {
      id: "BR_svg__filter0_d_4799_265981",
      x: 3.809,
      y: 3.704,
      width: 24.32,
      height: 16.467,
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB"
    },
    /* @__PURE__ */ e.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
    /* @__PURE__ */ e.createElement(
      "feColorMatrix",
      {
        in: "SourceAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }
    ),
    /* @__PURE__ */ e.createElement("feOffset", null),
    /* @__PURE__ */ e.createElement("feColorMatrix", { values: "0 0 0 0 0.0313726 0 0 0 0 0.368627 0 0 0 0 0 0 0 0 0.28 0" }),
    /* @__PURE__ */ e.createElement(
      "feBlend",
      {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_4799_265981"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "feBlend",
      {
        in: "SourceGraphic",
        in2: "effect1_dropShadow_4799_265981",
        result: "shape"
      }
    )
  ))
);
export {
  t as default
};
